module.exports = __webpack_public_path__ + "img/logo.3efa32cc.png";